import { useLayoutEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import tippy from 'tippy.js';

/**
 * Attach a tippy.js instance to the element given to `ref`, rendering React `content` into it.
 *
 * @returns {[function(Element|null): void, import('react').ReactPortal]} [ref, portal]
 */
export default function useTippy(content, props = {}) {
	const [element, setElement] = useState(null);
	const [container] = useState(() => document.createElement('div'));
	const instance = useRef(null);
	
	// Same base props @tippy.js/react used: skip data-tippy-* parsing and allow re-creating on the same element
	const tippy_props = { ignoreAttributes: true, multiple: true, ...props, content: container };
	
	useLayoutEffect(() => {
		if (! element) {
			return;
		}
		
		instance.current = tippy(element, tippy_props);
		
		return () => {
			instance.current.destroy();
			instance.current = null;
		};
	}, [element]); // oxlint-disable-line react-hooks/exhaustive-deps, react/exhaustive-effect-dependencies -- later prop changes go through setProps below
	
	useLayoutEffect(() => {
		instance.current?.setProps(tippy_props);
	});
	
	return [setElement, createPortal(content, container)];
}
